import React from "react";
import { object, string } from "prop-types";
import get from "lodash/get";

import "./story-card.m.css";

const CustomQuoteElement = ({ element = {}, shareUrl }) => {
  const authorName = get(element, ["metadata", "attribution"], null);
  const authorPhoto = get(element, ["metadata", "entity", "photo", "0", "url"], null);
  const elementText = get(element, ["metadata", "content"], null);

  return (
    <div className="story-element story-element-text story-element-text-quote">
      {elementText && <blockquote>{elementText}</blockquote>}
      {authorName && (
        <div className="attribution">
          {authorPhoto && <img className="person-image" src={authorPhoto} alt={authorName} />}
          <span>{authorName}</span>
        </div>
      )}
    </div>
  );
};

CustomQuoteElement.propTypes = {
  element: object,
  shareUrl: string
};

export default CustomQuoteElement;
